import React from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "sr/helpers";
const Footer = () => {
  const Legalpages = [
    { name: "Privacy Policy", link: "https://janijobs.com/privacy-policy/" },
  ];
  return (
    <footer className="bg-white mt-8">
      <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div className="lg:grid md:grid lg:grid-cols-6 md:grid-cols-2 grid-cols-1 gap-8">
          <div className="col-span-1 mb-6 md:mb-0 w-full text-center lg:text-left">
            <Link
              to="/"
              className="flex items-center lg:mb-8 justify-center lg:justify-start"
            >
              <img
                width={150}
                src={toAbsoluteUrl("/media/logos/logo2.png")}
                className="mr-3"
                alt="Cleaner Job"
              />
            </Link>
            <p className=" text-sm lg:mb-4">Connect with us</p>
            <div className="flex mt-4 space-x-4 justify-center lg:justify-start">
              <a
                href="https://www.facebook.com/janijobs"
                className="text-gray-500 hover:text-gray-900 "
              >
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 8 19"
                >
                  <path
                    fillRule="evenodd"
                    d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="sr-only">Facebook page</span>
              </a>
              <a
                href="https://www.instagram.com/janijobs/"
                className="text-gray-500 hover:text-gray-900"
              >
                <svg
                  className="w-4 h-4 text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="150 150 250 250"
                >
                  <g>
                    <path d="M326,256c0,38.6-31.4,70-70,70c-38.6,0-70-31.4-70-70c0-9.3,1.9-18.2,5.2-26.3H153v104.8c0,13.5,11,24.5,24.5,24.5h157c13.5,0,24.5-11,24.5-24.5V229.7h-38.2C324.2,237.8,326,246.7,326,256z" />
                    <polygon points="354.4,200.9 354.4,163.1 354.4,157.5 348.8,157.5 311,157.6 311.2,201" />

                    <polygon points="157.6,200.9 157.6,163.1 157.6,157.5 163.2,157.5 201,157.6 200.8,201" />

                    <path d="M256,301c24.8,0,45.1-20.2,45.1-45.1c0-9.8-3.2-18.9-8.5-26.3c-8.2-11.3-21.5-18.8-36.5-18.8s-28.3,7.4-36.5,18.8c-5.3,7.4-8.5,16.5-8.5,26.3C211,280.8,231.2,301,256,301z" />
                  </g>
                </svg>

                <span className="sr-only">Instagram</span>
              </a>

              <a
                href="https://www.tiktok.com/@janijobs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-gray-900"
              >
                <svg
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.68h-3.13v12.26a2.84 2.84 0 1 1-2.84-2.84c.23 0 .46.03.68.08V8.33a5.97 5.97 0 0 0-.68-.04A5.97 5.97 0 1 0 15.82 14V8.11a7.94 7.94 0 0 0 4.77 1.59V6.69z" />
                </svg>
                <span className="sr-only">TikTok</span>
              </a>
              <a
                href="https://x.com/jani_jobs"
                className="text-gray-500 hover:text-gray-900 "
              >
                <svg
                  className="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 17"
                >
                  <path
                    fillRule="evenodd"
                    d="M20 1.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.344 8.344 0 0 1-2.605.98A4.13 4.13 0 0 0 13.85 0a4.068 4.068 0 0 0-4.1 4.038 4 4 0 0 0 .105.919A11.705 11.705 0 0 1 1.4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 4.1 9.635a4.19 4.19 0 0 1-1.856.07 4.108 4.108 0 0 0 3.831 2.807A8.36 8.36 0 0 1 0 14.184 11.732 11.732 0 0 0 6.291 16 11.502 11.502 0 0 0 17.964 4.5c0-.177 0-.35-.012-.523A8.143 8.143 0 0 0 20 1.892Z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="sr-only">Twitter page</span>
              </a>
              <a
                href="https://www.linkedin.com/company/janijobs"
                className="text-gray-500 hover:text-gray-900"
              >
                <svg
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  version="1.1"
                  viewBox="0 0 93.06 93.06"
                >
                  <g>
                    <g>
                      <path d="M11.185,0.08C5.004,0.08,0.001,5.092,0,11.259c0,6.173,5.003,11.184,11.186,11.184c6.166,0,11.176-5.011,11.176-11.184    C22.362,5.091,17.351,0.08,11.185,0.08z" />
                      <rect
                        x="1.538"
                        y="30.926"
                        width="19.287"
                        height="62.054"
                      />
                      <path d="M69.925,29.383c-9.382,0-15.673,5.144-18.248,10.022h-0.258v-8.479H32.921H32.92v62.053h19.27V62.281    c0-8.093,1.541-15.932,11.575-15.932c9.89,0,10.022,9.256,10.022,16.451v30.178H93.06V58.942    C93.06,42.235,89.455,29.383,69.925,29.383z" />
                    </g>
                  </g>
                </svg>
                <span className="sr-only">Linked In</span>
              </a>
            </div>
          </div>
          <div className="col-span-1 w-full text-center lg:text-left">
            <h2 className="lg:mb-6 mb-2 uppercase font-bold text-base">
              Resources
            </h2>
            <ul className="  text-sm font-semibold text-gray">
              <li className="mb-2">
                <Link to="/cleaner-jobs" className="hover:underline">
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <a
                  href="https://janijobs.com/about-us/"
                  className="hover:underline"
                >
                  About us
                </a>
              </li>
            </ul>
          </div>
          <div className="col-span-1 w-full text-center lg:text-left">
            <h2 className="lg:mb-6 mb-2 mt-6 lg:mt-0 uppercase font-bold text-base">
              Users/JobSeekers
            </h2>
            <ul className="  text-sm font-semibold text-gray">
              <li className="mb-2">
                <Link to="/cleaner-jobs" className="hover:underline ">
                  Jobs
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/companies" className="hover:underline ">
                  Companies
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-span-1 w-full text-center lg:text-left">
            <h2 className="lg:mb-6 mb-2 mt-6 lg:mt-0 uppercase font-bold text-base">
              Legal
            </h2>
            <ul className="  text-sm font-semibold text-gray">
              {Legalpages.map((data, index) => (
                <li key={index} className="mb-2">
                  <a href={data.link} className="hover:underline">
                    {data.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-2 w-full text-center lg:text-left">
            <div className="border border-gray-border rounded-xl p-4 inline-block w-auto">
              <p className=" text-sm lg:mb-1">Apply on the go</p>
              <p className=" text-xs">Get real-time job updates on our App</p>
              <div className="flex space-x-4 pt-4 justify-center mx-auto">
                <img
                  src={toAbsoluteUrl("/media/img/playstore.png")}
                  className="w-auto"
                ></img>
                <img
                  src={toAbsoluteUrl("/media/img/iosstore.png")}
                  className="w-auto"
                ></img>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className="border-gray-200" />
      <div className="flex items-center py-4 max-w-screen-xl mx-auto">
        <span className="text-sm  sm:text-center">
          © 2023{" "}
          <Link to="/" className="hover:underline">
            Jobweb™
          </Link>
          . All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
